import { UseQueryOptions } from 'react-query'

import { useGremlinQuery } from 'hooks/use-gremlin-query'
import { ReliabilityTestRun } from 'types/api/reliability-tests/runs'

const INITIAL_DATA = [] as ReliabilityTestRun[]

export function useActiveReliabilityTests(
  useQueryOptions?: UseQueryOptions<ReliabilityTestRun[]>
) {
  const {
    data,
    isFetching: isFetchingActiveReliabilityTests,
    isError: hasErrorActiveReliabilityTests,
    refetch: refetchActiveReliabilityTests
  } = useGremlinQuery<ReliabilityTestRun[]>(
    'reliability-tests/active',
    {},
    {
      staleTime: 10_000,
      refetchInterval: 10_000,
      ...useQueryOptions,
      placeholderData: INITIAL_DATA
    }
  )

  return {
    activeReliabilityTests: data ?? INITIAL_DATA,
    hasErrorActiveReliabilityTests,
    isFetchingActiveReliabilityTests,
    refetchActiveReliabilityTests
  }
}
